module.exports = __webpack_public_path__ + "9cd8313d8cb619c7b5e5fed84344ba59.pdf";